import status from './reducers'

export { setPing, setPong, setGoogle, setIntegration, setErrors, addError, removeError } from './actions'
export { getStatus, getIntegrationStatus, getGeneralErrors } from './selectors'

export default status
